import React, { useState, useEffect } from "react";
import { Header, Table } from 'react-frontier2';
import { Link } from "react-router-dom";
import { EventSectionProps } from '../../AdminClasses';
import { addCommas } from "@arema/components/Util";
import API from "../../API";
import moment from "moment";

interface QuestionsEventDate {
	date_id: number,
	event_id: number,
	date: number,
	venue_name: string,
	city: string,
	questions: number
}

var EventFormsContainer = (props: EventSectionProps)=>{
	var [dates, setDates] = useState<QuestionsEventDate[]>(null);
	var [loadError, setLoadError] = useState<string>(null);

	var loadDatesForms = ()=>{
		API.getEventDateForms(props.event.event_id).then(res=>{
			if(res.error) return setLoadError(res.message);
			setDates(res.data);
		}).catch(err=>{
			setLoadError('Hubo un error cargando los calendarios. (LCL-1)');
		});
	}

	useEffect(()=>{
		if(!dates){
			loadDatesForms();
		}
	}, []);

	if(loadError) return <Header text="Error" subtext={loadError} />
	if(!dates) return <Header loading text="Cargando calendarios" />

	return <Table style={{ maxWidth: 800, margin: 'auto' }}>
		<Table.Head
			title="Calendarios"
			data={[['ID', 'Fecha', 'Recinto', 'Ciudad', 'Preguntas']]}
		/>
		<Table.Body>
			{dates.length===0 && (
				<Table.Cell empty row colSpan={100} value={'No hay calendarios en este evento'} />
			)}
			{dates.map(a=>(
				<Table.Row
					compact selectable
					key={a.date_id}
					collapsingIndexes={[0, 1, 3, 4]}
					centeredIndexes={[4]}
					as={Link} 
					to={`/events/${a.event_id}/forms/${a.date_id}`} 
					data={[
						a.date_id,
						moment.unix(a.date).format('DD/MMM/YY HH:mm'),
						a.venue_name,
						a.city,
						addCommas(a.questions || 0, false)
					]} 
				/>
			))}
		</Table.Body>
	</Table>
}

export default EventFormsContainer;